export default {
  installer: {
    companyName: '',
    oftecNumber: '',
    address: '',
    tel: '',
    email: ''
  },
  installation: {
    address: '',
    postCode: '',
    customerName: ''
  },
  equipment: {
    applianceType: '',
    make: '',
    model: '',
    burnerType: '',
    fuelType: ''
  },
  certification: {
    installationDate: '',
    certificateNumber: '',
    engineerSignature: '',
    engineerName: '',
    customerSignature: ''
  },
  combustion: {
    combustionTestPerformed: 'No',
    o2Pct: '',
    co2Pct: '',
    coPpm: '',
    flueTempC: '',
    ambientTempC: 20,
    smokeNumber: '',
    pumpPressureBar: '',
    vacuumReadingMbar: ''
  },
  supplyAndTank: {
    supplySystem: '',
    tigerloopFitted: 'No',
    oilFilterCondition: '',
    fireValveFitted: 'No',
    fireValveTripC: '',
    tankType: '',
    tankCapacityLitres: '',
    distanceToBuildingM: '',
    distanceToBoundaryM: '',
    fireScreenFitted: 'No'
  }
};
